import { PublicKey } from "@solana/web3.js";
import { MetaSaleInfo, OutbidSale } from "@axvdex/types/solana/outbid";

// Static mock data for outbid sales ==========================================

export const mockSaleInfo = (id: number, status: MetaSaleInfo["status"]): MetaSaleInfo => ({
  id,
  status,
});

// INSTRUCTION: Paste the sale in the `sales` array to add a new sale and in the `salesState` object to add the sale state
export const localStaticOutbids: OutbidSale[] = [
  {
    name: "Astrovault-Solana",
    status: "live",
    projectSymbol: "AXV",
    description: "DeFi, Sustainably.",
    raised: 1234564000000,
    projectLinks: [{ url: "https://astrovault.io/landing", label: "Astrovault" }],
    // PASTER HERE =============================================================
    sales: [
      // INSTRUCTION: Add your initialized sale here
      new PublicKey("5GBmAJS8caBmJ25u2V24u5Rpjmi61mCY8n9tUBxbqAHb"),
      new PublicKey("6uu2cm1vHHRa1hbJSeUA3fjQ4Ls5BVX2zx6gLumTz89g"),
      new PublicKey("6digC4B9aajLD1z1jERxxFb2PC3kxG6bLnhReUc1QwTo"),
    ],
    salesState: {
      // INSTRUCTION: Add your initialized sale address here
      "5GBmAJS8caBmJ25u2V24u5Rpjmi61mCY8n9tUBxbqAHb": mockSaleInfo(0, "Bidding"),
      "6uu2cm1vHHRa1hbJSeUA3fjQ4Ls5BVX2zx6gLumTz89g": mockSaleInfo(1, "Bidding"),
      "6digC4B9aajLD1z1jERxxFb2PC3kxG6bLnhReUc1QwTo": mockSaleInfo(2, "WaitingToStart"),
    },
    assets: {
      // INSTRUCTION: Add your assets here
      "Bs2c8Rd1pAxjfLWaBe5L727i5oEuNqiVngEYSDpqNrAo": {
        mint: new PublicKey("Bs2c8Rd1pAxjfLWaBe5L727i5oEuNqiVngEYSDpqNrAo"),
        decimals: 9,
        symbol: "TEST",
        price: 12,
      },
      GNc8PDJAYeY2wP5sLC28mKRH2Q6TG4n55rha5HUmAe33: {
        mint: new PublicKey("GNc8PDJAYeY2wP5sLC28mKRH2Q6TG4n55rha5HUmAe33"),
        decimals: 9,
        symbol: "AXV",
        price: 12,
      },
    },
    saleAuthority: "CCnjufSChVe1AeAJ6QJWGFxUkagWVTzYHe4mCwAfRPhy",
    // =========================================================================
    address: process.env.REACT_APP_SOLANA_OUTBID_PROGRAM_ID,
    defaultSaleSettings: {
      id: 1,
      target_asset_allocation_amount: 100000000000,
      target_asset_decimals: 6,
      target_ticket_amount: 100000000000,
      min_ticket: 1,
      max_ticket: 10,
      wallet_max_ticket_cap: 10,
      duration: 100,
      bonus_duration: 10,
      whitelist_duration: 100,
      bonus_sell_out_bonus_token_per: 0,
      bonus_min_ticket_increase: 2,
      bonus_sell_out_elegible_token_per: 1,
      bid_assets: [],
    },
    nftSaleImages: [
      [
        [
          "https://i.seadn.io/s/raw/files/46d792a7c8576fdef520a2a52e4d4bc9.png?auto=format&dpr=1&w=1000",
          "https://i.seadn.io/s/raw/files/85efb7fc95983e86a0907422efc0e6c2.png?auto=format&dpr=1&w=1000",
        ],
        ["https://i.seadn.io/s/raw/files/dcae2ec2341b5472cc122f650b1244be.png?auto=format&dpr=1&w=1000"],
        ["https://i.seadn.io/s/raw/files/3ad8c8ef7d509b9265f823c68c9ce5d8.png?auto=format&dpr=1&w=1000"],
      ],
      [
        [
          "https://i.seadn.io/s/raw/files/46d792a7c8576fdef520a2a52e4d4bc9.png?auto=format&dpr=1&w=1000",
          "https://i.seadn.io/s/raw/files/85efb7fc95983e86a0907422efc0e6c2.png?auto=format&dpr=1&w=1000",
        ],
        ["https://i.seadn.io/s/raw/files/dcae2ec2341b5472cc122f650b1244be.png?auto=format&dpr=1&w=1000"],
        ["https://i.seadn.io/s/raw/files/3ad8c8ef7d509b9265f823c68c9ce5d8.png?auto=format&dpr=1&w=1000"],
      ],
      [
        [
          "https://i.seadn.io/s/raw/files/46d792a7c8576fdef520a2a52e4d4bc9.png?auto=format&dpr=1&w=1000",
          "https://i.seadn.io/s/raw/files/85efb7fc95983e86a0907422efc0e6c2.png?auto=format&dpr=1&w=1000",
        ],
        ["https://i.seadn.io/s/raw/files/dcae2ec2341b5472cc122f650b1244be.png?auto=format&dpr=1&w=1000"],
        ["https://i.seadn.io/s/raw/files/3ad8c8ef7d509b9265f823c68c9ce5d8.png?auto=format&dpr=1&w=1000"],
      ],
    ],
  },
  // {
  //   name: "Lunarspace",
  //   status: "vesting",
  //   projectSymbol: "LUNA",
  //   description: "Flexible digital workspace solutions",
  //   raised: 100000000000,
  //   projectLinks: [{ url: "https://lunarspace.io/", label: "Lunarspace" }],
  //   sales: [
  //     new PublicKey("2TbFXWqhVWxJPFH4ytWekA1Kh3Q1XYcf4FoqYCkm6rtj"),
  //     new PublicKey("FQ6MehkmLDyLFetJwJNwW5vtngQYg316vttDvxJUgwCp"),
  //   ],
  //   salesState: {
  //     "2TbFXWqhVWxJPFH4ytWekA1Kh3Q1XYcf4FoqYCkm6rtj": mockSaleInfo(1, "EndedSoldOut"),
  //     FQ6MehkmLDyLFetJwJNwW5vtngQYg316vttDvxJUgwCp: mockSaleInfo(2, "EndedNotSoldOut"),
  //   },
  //   address: "Lunarspace_mock_address",
  //   config: {
  //     id: 2,
  //     operator: "operator_mockAddress",
  //     owner: "owner_mockAddress",
  //     cw721_addr: new PublicKey("6k4XWaV2FLLYQhTkqD1gZhctbBawbX9yLHk36ZNHAPy"),
  //     default_sale_settings: {
  //       id: 2,
  //       target_asset_allocation_amount: 100000000000,
  //       target_asset_decimals: 6,
  //       target_ticket_amount: 100000000000,
  //       min_ticket: 1,
  //       max_ticket: 10,
  //       duration: 100,
  //       bonus_duration: 10,
  //       whitelist_duration: 100,
  //       bonus_sell_out_bonus_token_per: 0,
  //       bonus_min_ticket_increase: 2,
  //       bonus_sell_out_elegible_token_per: 1,
  //       wallet_max_ticket_cap: 10,
  //       bid_assets: [],
  //     },
  //     cw721_incentives: "ntf_mockAddress",
  //   },
  //   saleVestings: {
  //     vestingAddr: new PublicKey("6k4XWaV2FLLYQhTkqD1gZhctbBawbX9yLHk36ZNHAPy"),
  //   },
  //   nftSaleImages: [],
  // },
];
